import { useStrings } from "@1js/localization-components";
import { Text, makeStyles } from "@fluentui/react-components";
import * as React from "react";
import type { LinkedPrompt } from "../../services/prompt-client.web";
import { ManageAccessDialogListHeader } from "./ManageSharedPrompts.strings";
import { SharedPrompt } from "./SharedPrompt";
type SharedPromptsListProps = {
  prompts: LinkedPrompt[];
  onDeletePrompt: (prompt: LinkedPrompt) => void;
};

const useStyles = makeStyles({
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  table: {
    height: "320px",
    flexShrink: "0",
    alignSelf: "stretch",
    "@media (max-width: 540px)": {
      height: "auto",
    },
  },
  label: {
    display: "flex",
    width: "301px",
    alignItems: "flexEnd",
    gap: "4px",
  },
  labelText: {
    fontFamily: "Segoe UI",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "20px",
  },
});

export const SharedPromptsList: React.FC<SharedPromptsListProps> = ({
  prompts,
  onDeletePrompt,
}) => {
  const styles = useStyles();
  const strings = useStrings({
    ManageAccessDialogListHeader,
  });

  return (
    <div className={styles.table}>
      <div className={styles.label}>
        <Text className={styles.labelText}>
          {strings.ManageAccessDialogListHeader()}
        </Text>
      </div>
      <div className={styles.list}>
        {prompts.map((prompt) => (
          <SharedPrompt
            linkedPrompt={prompt}
            key={prompt.PromptId}
            onDeletePrompt={onDeletePrompt}
          />
        ))}
      </div>
    </div>
  );
};
